import { useQuery } from '@apollo/client';
import { useCountry } from '../../components/CountrySelector';
import { useUser } from '../useUser';
import { GET_ORDER_QUERY, GetOrderQuery, GetOrderQueryVariables } from './order.rest';

export const useOrder = (orderNumber: string) => {
  const { country } = useCountry();
  const {
    user: { accessToken }
  } = useUser();
  const { data, loading, error } = useQuery<GetOrderQuery, GetOrderQueryVariables>(
    GET_ORDER_QUERY,
    {
      variables: { countryCode: country.alpha2Code, orderNumber },
      skip: !orderNumber || !accessToken
    }
  );

  return { order: data?.getOrder.data[0], orderItems: data?.getOrder.included, loading, error };
};
